

export const colorPalette500 = [
  'text-navy-500/70',
  'text-red-500/70',
  'text-orange-500/70',
  'text-amber-500/70',
  'text-yellow-500/70',
  'text-lime-500/70',
  'text-teal-500/70',
  'text-green-500/70',
  'text-cyan-500/70',
  'text-indigo-500/70',
  'text-purple-500/70',
  'text-pink-500/70',
];

export const colorPalette500Bg = [
  'bg-navy-500/70',
  'bg-red-500/70',
  'bg-orange-500/70',
  'bg-amber-500/70',
  'bg-yellow-500/70',
  'bg-lime-500/70',
  'bg-teal-500/70',
  'bg-green-500/70',
  'bg-cyan-500/70',
  'bg-indigo-500/70',
  'bg-purple-500/70',
  'bg-pink-500/70',
];

export const colorPalette500Css = [
  '#f59e0be0',
  '#82d616e0',
  '#17c1e8e0',
  '#14b8a6e0',
  '#f53939e0',
  '#f97316e0',
  '#eab308e0',
  '#22c55ee0',
  '#6366f1e0',
  '#a855f7e0',
  '#ff0080e0',
  '#1b3bbbe0',
  '#6A646Ae0',
];

export const colorPalette500Hex = {
  goldenOrange: colorPalette500Css[0],
  lime: colorPalette500Css[1],
  lightBlue: colorPalette500Css[2],
  teal: colorPalette500Css[3],
  red: colorPalette500Css[4],
  orange: colorPalette500Css[5],
  yellow: colorPalette500Css[6],
  green: colorPalette500Css[7],
  indigoViolet: colorPalette500Css[8],
  purple: colorPalette500Css[9],
  pink: colorPalette500Css[10],
  blue: colorPalette500Css[11],
  gray: colorPalette500Css[12],
};

export class MutedNaturalColors {
  static baseGreen: string = '#98b68d';
  static mutedTan: string = '#b6a98d';
  static softSage: string = '#8db6a1';
  static mutedTeal: string = '#8db69e';
  static clayCoral: string = '#b6988d';
  static paleAqua: string = '#8db6af';
  static dustyRose: string = '#b68da3';
  static lavenderGray: string = '#a89cb6';
  static slateBlue: string = '#8d98b6';
  static mutedOchre: string = '#b6b08d';
  static stoneGray: string = '#9e9e9e';
  static warmTaupe: string = '#a98d98';
}
